import {Platform} from 'react-native';

import VisitWebsitePopover from '/component/partial/VisitWebsitePopover/VisitWebsitePopover';
import {openURL, openURLInNewTabOnWeb} from '/util/linking.util';

import {
  GenerateOnLearnMoreParams,
  GenerateOnLearnMoreReturnParams,
} from '../BusinessBuilderBonusBanner/BusinessBuilderBonusBanner.types';

export const generateOnLearnMore = ({
  popoverShow = () => {},
  currentScreen = '',
}: GenerateOnLearnMoreParams): GenerateOnLearnMoreReturnParams => {
  const URL = 'https://coachanswers.optavia.com/help/incentive-trip-2024';
  return () => {
    if (Platform.OS === 'web') {
      openURLInNewTabOnWeb(URL);
      return;
    }

    popoverShow(VisitWebsitePopover, {
      currentScreen: currentScreen,
      destinationURL: URL,
      onSubmit: () => openURL('url', URL),
    });
  };
};
